export const themes = {
  primaryColor: "#000000",
  secondaryColor: "#11682e",
  textTransform: "uppercase",
  primaryFont: "Aventgarde,TeX Gyre Adventor,URW Gothic L,sans-serif",
};
